import type { DmMessageTriagePatch } from '../services/dmMessagesInbox';
import { apiErrorCode, apiErrorMessage } from '../utils/apiError.ts';

// The backend's 409 code when triage is set on a conversation already reviewed, e.g. via Mark all.
const CONVERSATION_NOT_OPEN = 'CONVERSATION_NOT_OPEN';
export const CONVERSATION_ALREADY_REVIEWED = 'This conversation was already reviewed';

function fallbackMessage(patch: DmMessageTriagePatch): string {
    return patch.urgency === undefined
        ? 'Failed to update frustration'
        : 'Failed to update priority';
}

export function triageFailureMessage(error: unknown, patch: DmMessageTriagePatch): string {
    if (apiErrorCode(error) === CONVERSATION_NOT_OPEN) return CONVERSATION_ALREADY_REVIEWED;
    return apiErrorMessage(error, fallbackMessage(patch));
}
